// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_ZBdq7 {
  height: 52px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.metricContainer_dl12G {
  display: flex;
}

.metricText_elDc5 {
  font-size: 14px !important;
}

.periodComparisonText_GIznN {
  width: 74px;
  font-size: 14px !important;
  font-weight: 700 !important;
}

.greenText_kzbdL {
  color: var( --color-success700 ) !important;
}

.redText_BSGYv {
  color: var( --color-danger700 ) !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/attributes/renderers/location/Performance.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":[".container {\n  height: 52px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.metricContainer {\n  display: flex;\n}\n\n.metricText {\n  font-size: 14px !important;\n}\n\n.periodComparisonText {\n  width: 74px;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n}\n\n.greenText {\n  color: var( --color-success700 ) !important;\n}\n\n.redText {\n  color: var( --color-danger700 ) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_ZBdq7`,
	"metricContainer": `metricContainer_dl12G`,
	"metricText": `metricText_elDc5`,
	"periodComparisonText": `periodComparisonText_GIznN`,
	"greenText": `greenText_kzbdL`,
	"redText": `redText_BSGYv`
};
export default ___CSS_LOADER_EXPORT___;
